import { PublicationService } from './../../Service/publications.services';
import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Global } from 'src/app/Service/global.service';
declare var blueimp: any;
declare var $:any;

@Component({
  selector: 'app-centre-media',
  templateUrl: './centre-media.component.html',
  styleUrls: ['./centre-media.component.scss']
})
export class CentreMediaComponent implements OnInit {

  constructor(
    public global: Global,
    private service: PublicationService,
    private aroute: ActivatedRoute,
    private router: Router

  ) { }
  images = [];
  topImages = [];

  @Input()
  topImage = true;

  currentlang = '';
  lgsub;
  routesub;
  currentUrl;
  outputLg;
  section;
  urlSection;
  fromSimulatorPage = false;
  titrePhoto = '';

  ngOnInit(): void {
    this.lgsub = this.global.CurentLanguage.pipe(takeUntil(this.global.navigationEnd)).subscribe(lg => {

      this.outputLg = lg;
      this.routesub ? this.routesub.unsubscribe() : null;
      this.routesub = this.aroute.params.subscribe(param => {
        this.service.getPhototheque(lg.url).subscribe(datas => {
          this.currentlang = lg.url;
          this.currentUrl = this.router.url
          const url = this.router.url;

          this.currentUrl = this.router.url
          if (url.indexOf('/agence/') !== -1) {
            this.section = 'Agence';
            this.urlSection = '/agence/presentation'
          } else if (url.indexOf('/grands-chantiers/') !== -1) {
            this.section = 'Grands Chantiers';
            this.urlSection = '/grands-chantiers/chantiers-infrastructures'
          } else if (url.indexOf('/missions/') !== -1) {
            this.section = 'Missions';
            this.urlSection = '/missions/PortAuthorite'
          } else if (url.indexOf('/formation-portuaire/') !== -1) {
            this.section = 'Formation Portuaire';
            this.urlSection = '/formation-portuaire/ifp'
          } else if (url.indexOf('/services/') !== -1) {
            this.section = 'Services';
            this.urlSection = '/services/portnet'
          } else if (url.indexOf('/publications/') !== -1) {
            this.section = 'Publications';
            this.urlSection = '/publications/communiques-presse'
          } else if (url.indexOf('/espace-professionnel/') !== -1) {
            this.section = 'Espace Professionnel';
            this.urlSection = '/espace-professionnel/portnet'
          }
          datas['value'].forEach(element => {
            if(element.File !== null &&element.File !== undefined ) {
              const obj = {

                src: this.global._baseUrlBrute + element.File.ServerRelativeUrl,
                caption: element.FileLeafRef,
                thumb: this.global._baseUrlBrute + element.File.ServerRelativeUrl
              }
              this.images.push(obj);
            }
          

          });
          if (param["simulateur"] == "simulateur") {
            this.fromSimulatorPage = true;
            let u = lg.url.substring(this.global._baseUrlRacine.length);
            let titreSimulateur = 'Simulateur de l ANP';
            let photoAccueil = 'simulateur_carrefour.jpg' 
            if(lg.code ==='fr') {
              titreSimulateur = 'Simulateur de l ANP' ;
              photoAccueil = 'ifp_carrefour.jpg' 
            } else if(lg.code ==='ar') {
              titreSimulateur = 'معهد التكوين' ;
              photoAccueil = 'ifp_carrefour.jpg' 
            }else {
              titreSimulateur = 'ANP Simulator' ;
              photoAccueil = 'simulateur_carrefour.jpg' 
            }
     
            this.chargeGallery({ image: lg.url + "/Phototheque/"+ titreSimulateur+"/"+photoAccueil, url:  u + "/Phototheque/"+ titreSimulateur, title: titreSimulateur })
            } else {
            let folderUrl = lg.relativeUrl + '/Phototheque';
            if(lg.relativeUrl === undefined) {
              folderUrl = lg.code ==='fr' ? '/fra/Phototheque' : (lg.code ==='en' ?  '/eng/Phototheque' : '/arb/Phototheque');
            }
            this.service.getPhotothequeFolder(lg.url, folderUrl).subscribe(datas => {
              const requests = [];
              datas['value'].forEach(element => {
                requests.push(this.service.getPhotothequeFolder(lg.url, element.FileDirRef + '/' + element.FileLeafRef))
            
              });
              forkJoin(requests).subscribe(contents => {
                this.topImages = [];
                const topImagesTitle = [];
                contents.forEach(content => {
                  if (content['value'].length > 2) {
                    content['value'].forEach(item => {
                      if (item.FileLeafRef.toUpperCase().indexOf('.JPG') !== -1) {
                        const obj = {
                          image: this.global._baseUrlRacine + item.FileDirRef + '/' + item.FileLeafRef,
                          url: item.FileDirRef,
                          title: item.FileDirRef.split('/')[item.FileDirRef.split('/').length - 1],
                          id: item.Id
                        }
                        topImagesTitle.push(obj.title.toLowerCase())
                        this.topImages.push(obj);
                      }
                    });
                  }
                });
                if(param["simulateur"] !== null && param["simulateur"] !== undefined && topImagesTitle.indexOf(decodeURI(param["simulateur"].toLowerCase())) !== -1) {
                  this.chargeGallery(this.topImages[topImagesTitle.indexOf(decodeURI(param["simulateur"].toLowerCase()))]) 
                }
              });
              
            });
          }
        });
        this.service.getVideoTheque(this.outputLg.url).subscribe(datas => {
          const gallery = [];
          datas['value'].forEach(element => {
            const obj = {
              title: element.Title,
              type: 'text/html',
              href: element.Url,
              youtube: element.YoutubeId,
            }
            gallery.push(obj);
          });
          blueimp.Gallery(gallery, {
            container: '#blueimp-gallery-carousel',
            carousel: true,
            onopened : function(){
              let li = $('ol.indicator li')
              this.pause();
              for (let index = 0; index < li.length; index++) {
                const element = $(li[index]);
                element.html("<img src='https://img.youtube.com/vi/"+gallery[index].youtube+"/default.jpg' width='80px'/>")
                
              }
              // $('ol.indicator').appendTo( ".newol" );
            }
          });
    
        });
      });
    });

  }
  // ngAfterViewInit() {
  //    document.getElementById('links').onclick = (event: Event) => {
  //       event= event || window.event
  //       var target = event.target || event.srcElement
  //       var link = target['src'] ? target['parentNode'] : target
  //       var options = { index: link, event: event }
  //       var links =  document.getElementById('links').getElementsByTagName('a')
  //       blueimp.Gallery(links, options)
  //     }
  // }
  setToTrue() {
    this.topImage = true
      this.service.getVideoTheque(this.outputLg.url).subscribe(datas => {
        const gallery = [];
        datas['value'].forEach(element => {
          const obj = {
            title: element.Title,
            type: 'text/html',
            href: element.Url,
            youtube: element.YoutubeId,
          }
          gallery.push(obj);
        });
        blueimp.Gallery(gallery, {
          container: '#blueimp-gallery-carousel',
          carousel: true,
          onopened : function(){
            let li = $('ol.indicator li')
            this.pause();
            for (let index = 0; index < li.length; index++) {
              const element = $(li[index]);
              element.html("<img src='https://img.youtube.com/vi/"+gallery[index].youtube+"/default.jpg' width='80px'/>")
              
            }
            // $('ol.indicator').appendTo( ".newol" );
          }
        });
  
      });
  }
  chargeGallery(item) {
   this.titrePhoto = item.title;
    this.topImage = false;
    const id = setInterval(() => {
      const div = document.getElementById('links');
      if (div) {
        forkJoin([this.service.getPhotothequeFolder(this.currentlang, item.url + '/petit'), this.service.getPhotothequeFolder(this.currentlang, item.url + '/grand')]).subscribe(datas => {

          datas[1]['value'].forEach(element => {
            const alink = document.createElement("a");
            alink['href'] = this.global._baseUrlRacine + element.FileDirRef + '/' + element.FileLeafRef;
            const title = element.FileLeafRef.toUpperCase().split('_GRAND')[0] + element.FileLeafRef.toUpperCase().split('_GRAND')[1];
            alink['title'] = title;
            datas[0]['value'].forEach(petit => {
              const titlepETIT = petit.FileLeafRef.toUpperCase().split('_PETIT')[0] + petit.FileLeafRef.toUpperCase().split('_PETIT')[1];
              if (titlepETIT === title) {
                const img = document.createElement("img");
                img.src = this.global._baseUrlRacine + petit.FileDirRef + '/' + petit.FileLeafRef;
                img.setAttribute('Alt', title.split('.')[0]);
                img.setAttribute('Title', title.split('.')[0]);
                alink.append(img);
              }
            });
            div.append(alink);
          });
          document.getElementById('links').onclick = (event: Event) => {
            event = event || window.event
            var target = event.target || event.srcElement
            var link = target['src'] ? target['parentNode'] : target
            var options = { index: link, event: event }
            var links = document.getElementById('links').getElementsByTagName('a')
            blueimp.Gallery(links, options)
          }
        });
        clearInterval(id);
      }

    }, 1000);
  }
  ngOnDestroy() {
    this.lgsub.unsubscribe();
  }

}
